<template>
  <div class="MaintenanceRecord">
    <div class="commonTitle">
      <h4><span>1</span>维修记录</h4>
    </div>
    <div class="commonContentBox">
      <ul v-if="recordList.length">
        <li v-for="(v, i) in recordList" :key="i">
          <h5>{{ v.time }}</h5>
          <p>{{ v.description }}</p>
        </li>
      </ul>
      <el-empty v-else description="暂无数据"></el-empty>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  props: ["activeItem"],
  data() {
    return {
      recordList: [],
    };
  },
  methods: {
    async getDataList() {
      let res = await api.devicesMaintenance({
        deviceId: this.activeItem.deviceId
          ? this.activeItem.deviceId
          : this.activeItem.id.id,
      });
      if (res && res.data.code == 200) {
        this.recordList = res.data.data;
      }
    },
  },
  created() {
    this.getDataList();
  },
};
</script>

<style lang="scss" scoped>
.MaintenanceRecord {
  width: 100%;
  height: 100%;
  .commonContentBox {
    ul {
      width: 90%;
      margin: 0 auto;
      height: 100%;
      overflow: auto;
      li {
        min-height: 90px;
        @include setFlexColumn;
        justify-content: center;
        h5 {
          font-size: 14px;
          margin: 0 0 10px 20px;
        }
        p {
          font-size: 14px;
          margin-left: 20px;
        }
      }
      li:nth-child(odd) {
        background: #f7f7f7;
      }
      li:nth-child(even) {
        border: 1px solid #f7f7f7;
      }
    }
  }
}
</style>